module.exports = __webpack_public_path__ + "static/img/12.d7e99c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/12.png
// module id = 73Tg
// module chunks = 1